import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Buttons from '../../core/Buttons';
import DateFormat from '../../core/DateFormat';
import Truncate from '../../core/Truncate';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Opacity from '../../../utils/animations/opacity';

export const StyledWrapperComment = styled.div`
  ${props =>
    props.secondary &&
    css`
      opacity: 0;
      animation-name: ${Opacity};
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 0.5s;
    `};
  transition: all 0.5s linear;
  opacity: 1;
  max-height: ${rem('1500px')};
  overflow: hidden;
  &.hide {
    opacity: 0;
    max-height: 0;
    visibility: hidden;
  }
`;

// Capa contenedora del avatar
export const StyledWrapAvatar = styled.div`
  float: right;
  padding-top: ${rem('20px')};
  ${mediaqueries.greaterThan('tablet')`
    padding-top: ${rem('25px')};
  `};
`;
// Capa contenedora de cada comentario
export const StyledComment = styled.div`
  border-top: 1px solid ${props => props.theme.colors.grayLight};
  display: inline-block;
  line-height: 1.3rem;
  min-height: 4.6rem;
  padding: ${rem('10px')} 0 0 ${rem('10px')};
  width: calc(100% - 5rem);
  ${props =>
    props.secondary &&
    css`
      margin: 0 0 0 ${rem('30px')};
      width: calc(100% - 6rem);
    `};
  ${mediaqueries.greaterThan('tablet')`
    min-height: 7rem;
    padding: ${rem('20px')} 0 0 ${rem('10px')};
    width: calc(100% - 7rem);
    ${props =>
      props.secondary &&
      css`
        width: calc(100% - 8rem);
      `};
  `};
`;

// Texto del comentario
export const StyleTextComment = styled(Truncate)`
  font-size: ${rem('13px')};
  line-height: 1rem;
  ${props =>
    props.disabled &&
    css`
      animation-name: ${Opacity};
      animation-iteration-count: 1;
      animation-timing-function: linear;
      animation-duration: 2.4s;
    `};
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.small};
    line-height: 1.3rem;
  `};
`;
// Texto de info de fecha y autor
export const StyleInfo = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('12px')};
  margin: 0;
  display: flex;
  justify-content: space-between;
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.small};
    margin: 0 0 0.5rem 0;
  `};
`;
// Texto de fecha
export const StyleDateFormat = styled(DateFormat)`
  font-family: ${props => props.theme.fonts.medium};
  margin-right: ${rem('10px')};
  ${mediaqueries.greaterThan('tablet')`
    margin-right: ${rem('15px')};
  `};
`;
// Texto enlace de leer más
export const StyleRead = styled.a`
  display: inline-block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('13px')};
  margin: 0 0 ${rem('12px')};
  &:hover {
    color: ${props => props.theme.colors.gray};
  }
  ${props =>
    props.inactive &&
    css`
      color: ${props => props.theme.colors.gray};
    `};
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.small}
  `};
`;

// Capa para el formulario de enviar respuesta
export const StyleFormAnswer = styled.div`
  text-align: right;
`;
export const StyleButtonsContainer = styled.div`
  display: flex;
  gap: ${rem('10px')};
`;

// Texto enlace de responder comentario
/* Efecto a la capa de form StyleFormAnswer cuando seleccionas el boton */
export const StyleAnswer = styled(StyleRead)`
  margin-right: 1.25rem;
  ${props =>
    props.answerId &&
    css`
      color: ${props => props.theme.colors.gray};
      ~ ${StyleFormAnswer} {
        transition: all 0.6s ease-in;
      }
    `};
`;

// Botón gost de responder
export const StyleButtons = styled(Buttons)`
  border: ${rem('2px')} solid ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.secondary};
  font-size: ${rem('12px')};
  height: auto;
  margin-bottom: ${rem('20px')};
  padding: ${rem('8px')} ${rem('15px')};

  &:hover,
  &:active {
    background-color: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.light};
  }
  ${props =>
    props.disabled &&
    css`
      opacity: 0.6;
      &:hover {
        background-color: transparent;
        color: ${props => props.theme.colors.secondary};
      }
    `};
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.small};
    padding: ${rem('8px')} ${rem('20px')};
  `};
`;
